import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

@Component({
  selector: 'toastr',
  templateUrl: './toastr.component.html',
  styleUrls: ['./toastr.component.scss']
})
export class ToastrComponent extends Toast implements OnInit {
  protected type: string = 'toast-info';
  protected iconColor: string = '';

  ngOnInit() {
    this.type = this.toastPackage.toastType;
    switch (this.type) {
      case 'toast-info':
        this.iconColor = 'text-info-500 bg-info-100/20';
        break;
      case 'toast-success':
        this.iconColor = 'text-green-500 bg-green-200/75';
        break;
      case 'toast-warning':
        this.iconColor = 'text-warning-500 bg-warning-100/50';
        break;
      case 'toast-error':
        this.iconColor = 'text-primary-500 bg-primary-100/25';
        break;
    }
  }
}
